import React from "react";
import { Navigate, Route, Routes } from "react-router";
import DashboardPage from "../Pages/MisDump/DashboardPage";
import LoginPage from "../Pages/MisDump/LoginPage";
import QuickPay from "../Pages/QuickPay";
import SummaryPage from "../Pages/QuickPay/SummaryPage/Index";
import ThankyouPage from "../Pages/QuickPay/ThankyouPage";
import PaymentTabs from "../Pages/QuickPay/paymentPage/paymentTabs";
import BelstarPage from "../Pages/QuickPay/belstar";
import SummaryBelstarPage from "../Pages/QuickPay/SummaryBelstarPage/Index";
import RedirectBack from "../Pages/QuickPay/Redirect/RedirectBack";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="">
        <Route index element={<QuickPay />} />
        <Route path="/campaign" element={<QuickPay isCampaign={true} />} />
        <Route path="/belstar" element={<BelstarPage />} />
        <Route path="/summary" element={<SummaryPage />} />
        <Route path="/belstar-summary" element={<SummaryBelstarPage />} />
        <Route path="/payment" element={<PaymentTabs />} />
        <Route path="/thankyou" element={<ThankyouPage />} />
     
        <Route path="/web-portal/fibe/journey" element={<RedirectBack />} />



      </Route>
      {/* MIS Dump Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
};

export default AppRoutes;
